<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <!-- overlay -->
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
              @click="overlay = false"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size: 30px" class="mb-0">Buscar Contratos</p>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        lg="6"
        xl="6"
        dense
        class="d-flex justify-end"
      >
        <!--
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="activarseguimiento">Seguimiento</v-btn>
          <v-btn @click="activaradministracion">Admin</v-btn>
        </v-btn-toggle>
        -->
      </v-col>
      <!-- Select requerimiento -->
      <!--
      <v-col cols="12" md="12" sm="12" xs="12" dense v-if="match">
        <v-row class="grey lighten-5">
          <v-col cols="12" md="12" sm="12" xs="12" lg="2" xl="2"></v-col>
          <v-col
            cols="12"
            md="12"
            sm="12"
            xs="12"
            lg="8"
            xl="8"
            class="justify-center"
          >
            <v-autocomplete
              v-model="requerimientoid2"
              :items="listarequerimientos2"
              class="mx-4"
              flat
              hide-no-data
              hide-details
              label="Buscar por actividad principal..."
              solo-inverted
              @change="editItem2"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" sm="12" xs="12" lg="2" xl="2"></v-col>
        </v-row>
      </v-col>
      -->
      <!-- Select requerimiento -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        dense
        v-if="postulacion || seguimiento"
      >
        <v-row class="grey lighten-5">
          <v-col cols="12" md="12" sm="12" xs="12" lg="2" xl="2"></v-col>
          <v-col
            cols="12"
            md="12"
            sm="12"
            xs="12"
            lg="8"
            xl="8"
            class="justify-center"
          >
            <!-- cache-items
            :search-input.sync="searchrequerimiento"-->
            <v-autocomplete
              v-model="requerimientoid"
              :items="listarequerimientos"
              class="mx-4"
              flat
              hide-no-data
              hide-details
              label="Buscar requerimiento..."
              solo-inverted
              @change="editItem"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8"></v-col>
        </v-row>
      </v-col>
      <!-- Match filtro y postulantes -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        dense
        class="mx-0 px-0"
        v-if="match"
      >
        <v-card mx-auto outlined>
          <!-- Fitro -->
          <v-row class="grey lighten-5">
            <v-col
              cols="12"
              md="12"
              sm="12"
              xs="12"
              lg="3"
              xl="3"
              class="mx-0 px-0"
            >
              <v-card class="mx-auto">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Contratos</v-list-item-title>
                    <v-list-item-subtitle>
                      <small>Filtros:</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <!--
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="4"
                      xl="4"
                      dense
                      class="pt-0"
                    >
                      <v-select
                        :items="sexos"
                        v-model="requerimientosexo"
                        dense
                        label="Sexo"
                        class="pt-0"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="4"
                      xl="4"
                      dense
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="requerimientoedadminima"
                        label="Edad minima"
                        class="pt-0"
                        type="number"
                        min="18"
                        max="50"
                        @keypress="onlyForCurrency"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="4"
                      xl="4"
                      dense
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="requerimiento_añosexperiencia"
                        label="Años de experiencia"
                        class="pt-0"
                        type="number"
                        min="0"
                        max="20"
                        @keypress="onlyForCurrency"
                        dense
                      ></v-text-field>
                    </v-col>
                    -->
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                    <v-checkbox
                        v-model="chktipoempresa"
                        hide-details
                        label="Filtrar por tipo de empresa"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="tipos_empresa"
                        :items="tipos_empresas"
                        label="Tipo empresa"
                        item-text="tipos_empresa"
                        :disabled="!chktipoempresa"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove4(data.item)"
                          >
                            <span>{{ data.item.tipos_empresa }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.tipos_empresa"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chktipolocacion"
                        hide-details
                        label="Filtrar por tipo de locación"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="requerimiento_tipolocacion"
                        :items="requerimiento_tiposlocacion"
                        label="Tipo de locación"
                        item-text="tipo_locacion"
                        :disabled="!chktipolocacion"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove5(data.item)"
                          >
                            <span>{{ data.item.tipo_locacion }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.tipo_locacion"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkclocacion"
                        hide-details
                        label="Filtrar por Clasificacion de locacion"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="clasificacion_locacion"
                        :items="clasificaciones_locacion"
                        :filter="customFilterCLocacion"
                        :disabled="!chkclocacion"
                        label="Clasificación de Locación"
                        item-text="clasificacion"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove(data.item)"
                          >
                            <span>{{ data.item.clasificacion }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.clasificacion"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0 mt-0"
                    >
                      <v-checkbox
                        v-model="chkfechas"
                        hide-details
                        label="Filtrar por fechas"
                        class="mt-0 pt-0 mb-2 pb-2"
                        ></v-checkbox>
                        <v-date-picker
                          mode="dateTime" 
                          v-model="fecha_inicio"
                          label="Fecha Inicio"
                          class="pt-0"
                          dense
                        ></v-date-picker>
                        <v-date-picker
                          mode="dateTime" 
                          v-model="fecha_fin"
                          label="Fecha Fin"
                          class="pt-0"
                          dense
                        ></v-date-picker>
                      <!--
                      <v-autocomplete
                        v-model="experiencia_principal"
                        :items="experiencias_principal"
                        :disabled="!chkfechas"
                        label="Experiencia"
                        item-text="puesto"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove2(data.item)"
                          >
                            <span>{{ data.item.puesto }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.puesto"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    -->
                    </v-col>
                    <div style="padding: 10px;"></div>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkmonto"
                        hide-details
                        label="Filtrar por monto"
                        class="mt-0 pt-0 mb-2 pb-2"
                        ></v-checkbox
                      >
                      <div style="padding: 20px;"></div>
                      <div id="app">
                        <div class="app-content">
                          <vue-range-slider v-model="montoslider" :min="min" :max="max" :formatter="formatter" :tooltip-merge="tooltipMerge" :enable-cross="enableCross"></vue-range-slider>
                        </div>
                      </div>
                      <!--  
                      <v-autocomplete
                        v-model="conocimiento_principal"
                        :items="conocimientos_principal"
                        :disabled="!chkmonto"
                        label="Conocimiento"
                        item-text="conocimiento"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove3(data.item)"
                          >
                            <span>{{ data.item.conocimiento }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.conocimiento"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                      <v-checkbox
                        v-model="chktrabajando"
                        hide-details
                        label="Filtrar considerando colaboradores"
                        class="mt-0 pt-0 mb-2 pb-2"
                        >></v-checkbox
                      >
                    -->
                    </v-col>
                  
                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
            <!-- Pre postulantes -->
            <v-col cols="12" md="12" sm="12" xs="12" lg="9" xl="9">
              <v-card class="mx-auto">
                <v-row dense>
                  <!--
                  <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          >Seleccionar postulantes</v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <v-chip class="ma-2">
                            <small class="pr-1">Total requerido:</small>
                            {{ requerimientocantidad }} persona(s)
                          </v-chip>
                          <v-chip class="ma-2" color="primary">
                            <small class="pr-1">Total seleccionado:</small>
                            {{ seleccionadoscantidad }} persona(s)
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                -->
                  <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" class="d-flex justify-end">
                    <!--
                    <v-btn
                      class="ma-2"
                      color="primary"
                      @click="ListarPostulantesVecinos"
                    >
                      <v-icon left>mdi-filter-plus-outline</v-icon>M. Vecinos
                    </v-btn>
                    -->
                    <v-btn
                      class="ma-2"
                      color="primary"
                      @click="ListarPostulantes"
                    >
                      <v-icon left>mdi-filter-plus-outline</v-icon>Filtrar
                    </v-btn>

                    <v-btn
                      class="ma-2 white--text"
                      color="light-blue darken-4"
                      @click="handleDownload"
                    >
                      <v-icon left>mdi-folder-multiple-plus-outline</v-icon
                      >Exportar
                    </v-btn>
                  </v-col>

      <!--            <div>
      <FilenameOption v-model="filename" />
      <AutoWidthOption v-model="autoWidth" />
      <BookTypeOption v-model="bookType" />
      <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" icon="el-icon-document" @click="handleDownload">
        Export Excel
      </el-button>
      <a href="https://panjiachen.github.io/vue-element-admin-site/feature/component/excel.html" target="_blank" style="margin-left:15px;">
        <el-tag type="info">Documentation</el-tag>
      </a>
    </div>-->
                  
                </v-row>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" dense>
                      <v-data-table
                        :headers="headercontratosempresas"
                        :items="contratosempresas"
                        height="300px"
                        class="elevation-1"
                        item-key="idcontratosempresas"
                        v-model="selectedRows"
                      >
                        <template v-slot:item="{ item }">
                          <tr
                            :class="
                              selectedRows.indexOf(item.idcontratosempresas) > -1
                                ? 'light-blue darken-4 white--text rounded-lg'
                                : ''
                            "
                            @click="rowClicked(item)"
                          >
                            <td class="text-sm-center">
                              <small>{{ item.razonsocial }}</small>
                            </td>
                            <td class="text-sm-center">
                              <small>{{ item.ruc }}</small>
                            </td>
                             <td class="text-sm-center">
                              <small>{{ item.giro_comercial }}</small>
                            </td>
                            <td class="text-sm-center">
                              <small>{{ item.fecha_inicio }}</small>
                            </td>
                            <td class="text-sm-center">
                              <small>{{ item.fecha_fin }}</small>
                            </td>
                            <td class="text-sm-center">
                              <small>{{ item.monto_contrato }}</small>
                            </td>
                            <td class="text-sm-left">
                              <small>{{ item.servicio_observaciones }}</small>
                            </td>
                            <td class="text-sm-left">
                              <small>{{ item.locacion }}</small>
                            </td>
                            <td class="text-sm-left">
                              <small>{{ item.licencia }}</small>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:no-data
                          >No existe contratos con los filtros
                          seleccionados</template
                        >
                        <template v-slot:no-results>NO RESULTS HERE!</template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Postulacion y programacion -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        dense
        class="mx-0 px-0"
        v-if="postulacion"
      >
        <v-card mx-auto outlined>
          <v-row class="grey lighten-5">
            <!-- Postulantes -->
            <v-col cols="12" md="4" sm="12" xs="12">
              <v-row>
                <!-- Postulantes elegidos -->
                <v-col cols="12" md="12" sm="12" xs="12">
                  <v-card class="mx-auto">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          >Postulantes elegidos</v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <v-chip class="ma-2" small>
                            <small class="pr-1">Total requerido:</small>
                            {{ requerimientocantidad }} persona(s)
                          </v-chip>
                          <v-chip small class="ma-2" color="primary">
                            <small class="pr-1">Total elegidos:</small>
                            {{ postulanteselegidoscantidad }} persona(s)
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-data-table
                            :headers="headerpostulanteselegidos"
                            :items="postulanteselegidos"
                            dense
                            hide-default-footer
                            hide-default-header
                            height="300px"
                            class="elevation-1"
                            item-key="idindividuo"
                          >
                            <template v-slot:item.acciones="{ item }">
                              <v-btn
                                x-small
                                color="primary"
                                dark
                                @click="eliminarPostulacion(item)"
                                >Eliminar</v-btn
                              >
                            </template>
                            <template v-slot:no-data
                              >No existe postulantes elegidos para este
                              requerimiento</template
                            >
                            <template v-slot:no-results
                              >No existe postulantes elegidos para este
                              requerimiento</template
                            >
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions></v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <!-- Programacion -->
            <v-col cols="12" md="8" sm="12" xs="12">
              <v-card class="mx-auto">
                <v-row>
                  <v-col cols="12" md="6" sm="12" xs="12">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          >Programacion de etapas</v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <small>Inicio y fin para cada etapa</small>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    sm="12"
                    xs="12"
                    class="d-flex justify-end pt-25 pb-5 pr-10"
                    style="padding-top: 25px"
                  >
                    <v-chip class="ma-1" color="red" outlined text-color="red">
                      Fecha de inicio del requerimiento:
                      <strong class="pl-1">{{
                        requerimientofecha_inicio.toString()
                      }}</strong>
                    </v-chip>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" dense>
                      <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-row>
                            <!--Etapa 1-->
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa1"
                                label="Etapa 1"
                                class="pt-0"
                                readonly
                              ></v-text-field>
                            </v-col>
                            <!--@keypress="onlyForCurrency"-->
                            <v-col
                              cols="12"
                              md="2"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa1duracion"
                                label="Duración"
                                class="pt-0"
                                min="1"
                                type="number"
                                :rules="[
                                  () => !!etapa1duracion || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa1duracion"
                                required
                                @click="generarFechaFin1"
                                @keypress="generarFechaFin1"
                                @keyup.up="generarFechaFin1"
                                @keyup.down="generarFechaFin1"
                                @mouseleave="generarFechaFin1"
                              ></v-text-field>
                            </v-col>
                            <!-- :rules="[() => !!etapa1fecha_inicio || 'Campo requerido']"
                                :error-messages="errorMessages"
                                ref="etapa1fecha_inicio"
                            required-->
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa1fecha_inicio"
                                label="Fecha inicio"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () =>
                                    !!etapa1fecha_inicio || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa1fecha_inicio"
                                required
                                @change="generarFechaFin1"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa1fecha_fin"
                                label="Fecha fin"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () => !!etapa1fecha_fin || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa1fecha_fin"
                                required
                                @change="generarFechaInicio2"
                              ></v-text-field>
                            </v-col>
                            <!--Etapa 2-->
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa2"
                                label="Etapa 2"
                                class="pt-0"
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="2"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa2duracion"
                                label="Duración"
                                class="pt-0"
                                type="number"
                                :rules="[
                                  () => !!etapa2duracion || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa2duracion"
                                min="1"
                                required
                                @click="generarFechaFin2"
                                @keypress="generarFechaFin2"
                                @keyup.up="generarFechaFin2"
                                @keyup.down="generarFechaFin2"
                                @mouseleave="generarFechaFin2"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa2fecha_inicio"
                                label="Fecha inicio"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () =>
                                    !!etapa2fecha_inicio || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa2fecha_inicio"
                                required
                                @change="generarFechaFin2"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa2fecha_fin"
                                label="Fecha fin"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () => !!etapa2fecha_fin || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa2fecha_fin"
                                required
                                @change="generarFechaInicio3"
                              ></v-text-field>
                            </v-col>
                            <!--Etapa 3-->
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa3"
                                label="Etapa 3"
                                class="pt-0"
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="2"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa3duracion"
                                label="Duración"
                                class="pt-0"
                                type="number"
                                :rules="[
                                  () => !!etapa3duracion || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa3duracion"
                                required
                                min="1"
                                @click="generarFechaFin3"
                                @keypress="generarFechaFin3"
                                @keyup.up="generarFechaFin3"
                                @keyup.down="generarFechaFin3"
                                @mouseleave="generarFechaFin3"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa3fecha_inicio"
                                label="Fecha inicio"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () =>
                                    !!etapa3fecha_inicio || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa3fecha_inicio"
                                required
                                @change="generarFechaFin3"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa3fecha_fin"
                                label="Fecha fin"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () => !!etapa3fecha_fin || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa3fecha_fin"
                                required
                                @change="generarFechaInicio4"
                              ></v-text-field>
                            </v-col>
                            <!--Etapa 4-->
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa4"
                                label="Etapa 4"
                                class="pt-0"
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="2"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa4duracion"
                                label="Duración"
                                class="pt-0"
                                type="number"
                                :rules="[
                                  () => !!etapa4duracion || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa4duracion"
                                required
                                min="1"
                                @click="generarFechaFin4"
                                @keypress="generarFechaFin4"
                                @keyup.up="generarFechaFin4"
                                @keyup.down="generarFechaFin4"
                                @mouseleave="generarFechaFin4"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <v-text-field
                                v-model="etapa4fecha_inicio"
                                label="Fecha inicio"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () =>
                                    !!etapa4fecha_inicio || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa4fecha_inicio"
                                required
                                @change="generarFechaFin4"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0"
                            >
                              <!-- @change="generarFechaInicio5"-->
                              <v-text-field
                                v-model="etapa4fecha_fin"
                                label="Fecha fin"
                                class="pt-0"
                                type="date"
                                :rules="[
                                  () => !!etapa4fecha_fin || 'Campo requerido',
                                ]"
                                :error-messages="errorMessages"
                                ref="etapa4fecha_fin"
                                required
                              ></v-text-field>
                            </v-col>
                            <!-- :disabled="overlay2" -->
                            <v-col cols="8" class="d-flex justify-start pt-0">
                              <v-row>
                                <v-col cols="12" v-if="fueradeplazo">
                                  <v-alert type="error" dense
                                    >Fuera de plazo: La fecha de contrato supera
                                    la fecha de inicio del requerimiento ({{
                                      requerimientofecha_inicio
                                    }})</v-alert
                                  >
                                </v-col>
                                <v-col cols="12" v-if="dentrodeplazo">
                                  <v-alert
                                    color="#2A3B4D"
                                    dark
                                    icon="mdi-thumb-up"
                                    dense
                                    >Dentro de plazo: La programacion esta
                                    acorde a la fecha de inicio del
                                    requerimiento ({{
                                      requerimientofecha_inicio
                                    }})</v-alert
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="4" class="d-flex justify-end">
                              <v-btn
                                color="primary"
                                class="mb-5"
                                @click="saveProgramacion"
                                >Guardar</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Seguimiento -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        lg="12"
        xl="12"
        dense
        class="mx-0 px-0"
        v-if="seguimiento"
      >
        <v-card mx-auto outlined>
          <v-row class="grey lighten-5">
            <!-- Resumen requerimiento y postulantes -->
            <!-- Resumen requerimiento -->
            <v-col cols="12" md="12" sm="12" xs="12" lg="3" xl="3">
              <v-card class="mx-auto">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Requerimiento</v-list-item-title>
                    <v-list-item-subtitle>
                      <small>Resumen:</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-select
                        :items="sexos"
                        v-model="requerimientosexo"
                        dense
                        label="Sexo"
                        class="pt-0"
                        disabled
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-text-field
                        v-model="requerimientoedadminima"
                        label="Edad minima"
                        class="pt-0"
                        type="number"
                        min="18"
                        max="50"
                        @keypress="onlyForCurrency"
                        dense
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-text-field
                        v-model="requerimiento_añosexperiencia"
                        label="Años de experiencia"
                        class="pt-0"
                        type="number"
                        min="1"
                        max="20"
                        @keypress="onlyForCurrency"
                        dense
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-autocomplete
                        v-model="requerimiento_tipo"
                        :items="requerimiento_tipos"
                        label="Tipo postulante"
                        item-text="tipo_postulante"
                        dense
                        chips
                        disabled
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove4(data.item)"
                          >
                            <span>{{ data.item.tipo_postulante }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.tipo_postulante"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-autocomplete
                        v-model="requerimiento_tipolocacion"
                        :items="requerimiento_tiposlocacion"
                        label="Grado academico"
                        item-text="tipo_educacion"
                        dense
                        chips
                        disabled
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove5(data.item)"
                          >
                            <span>{{ data.item.tipo_educacion }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.tipo_educacion"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-autocomplete
                        v-model="clasificacion_locacion"
                        :items="clasificaciones_locacion"
                        :filter="customFilterCLocacion"
                        disabled
                        label="Educación / Carrera"
                        item-text="clasificacion"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove(data.item)"
                          >
                            <span>{{ data.item.clasificacion }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.clasificacion"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      dense
                      class="pt-0 mt-0"
                    >
                      <v-autocomplete
                        v-model="experiencia_principal"
                        :items="experiencias_principal"
                        disabled
                        label="Experiencia"
                        item-text="puesto"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove2(data.item)"
                          >
                            <span>{{ data.item.puesto }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.puesto"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" dense class="pt-0">
                      <v-autocomplete
                        v-model="conocimiento_principal"
                        :items="conocimientos_principal"
                        disabled
                        label="Conocimiento"
                        item-text="conocimiento"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove3(data.item)"
                          >
                            <span>{{ data.item.conocimiento }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.conocimiento"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
            <!-- Seguimiento -->
            <v-col cols="12" md="12" sm="12" xs="12" lg="9" xl="9">
              <v-card class="mx-auto">
                <v-row>
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Seguimiento por etapas:
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-chip class="ma-0">
                            <small class="pr-1">Total requerido:</small>
                            {{ requerimientocantidad }} persona(s)
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <!--<v-select
                    :items="etapas"
                    v-model="etapa"
                    dense
                    label="Etapa"
                    color="primary"
                    class="pt-0"
                    :style="selectascolumn"
                    outlined
                    @change="listarPostulantesEtapa"
                  ></v-select>-->
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <!-- Steppers -->
                <v-stepper v-model="e6" vertical non-linear>
                  <!-- Etapa 1-->
                  <v-stepper-step
                    editable
                    :complete="e6 > 1"
                    step="1"
                    @click="listarPostulantesEtapa1"
                    :rules="[() => oketapa1]"
                  >
                    Revision de CV Documentado
                    <div class="d-flex">
                      <v-chip class="ma-1" small
                        >Del {{ postulantesetapa1fechainicio }} al
                        {{ postulantesetapa1fechafin }}</v-chip
                      >
                      <v-chip class="ma-1" color="teal darken-3" dark small
                        >Aptos: {{ postulantesetapa1aptos }}</v-chip
                      >
                      <v-chip class="ma-1" color="blue-grey darken-2" dark small
                        >No evaluados:
                        {{ postulantesetapa1noevaluados }}</v-chip
                      >
                      <v-chip
                        class="ma-1"
                        color="red darken-1"
                        text-color="white"
                        small
                        >No aptos: {{ postulantesetapa1noaptos }}</v-chip
                      >
                      <!--<small>Fecha:Inicio</small>-->
                    </div>
                  </v-stepper-step>
                  <!-- Etapa 1 Data Table -->
                  <v-stepper-content step="1" class="mb-1">
                    <!-- calculate-widths=true-->
                    <v-data-table
                      :headers="headeretapa"
                      :items="postulantesetapa1"
                      hide-default-footer
                      class="elevation-1 mt-2 mb-5"
                      dense
                    >
                      <template v-slot:item.acciones="{ item }">
                        <v-btn
                          x-small
                          color="primary"
                          dark
                          @click="actualizarPostulacionByPostualacion(item,1)"
                          >Guardar</v-btn
                        >
                      </template>
                      <template v-slot:item.individuo="{ item }">
                        <small>{{ item.individuo }}</small>
                        <v-chip
                          class="ma-2"
                          x-small
                          dark
                          color="blue-grey darken-4"
                          v-if="item.contratado"
                          >Contratado</v-chip
                        >
                      </template>
                      <template v-slot:item.estado="{ item }">
                        <v-select
                          :items="estados"
                          v-model="item.estado"
                          dense
                          hide-details
                          :disabled="item.contratado"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>{{ item.text }}</v-chip>
                          </template>
                        </v-select>
                      </template>
                      <template v-slot:item.observaciones="{ item }">
                        <v-text-field
                          v-model="item.observaciones"
                          dense
                          auto-grow
                          full-width
                          hide-details
                          class="mb-2"
                        ></v-text-field>
                      </template>
                      <template v-slot:no-data
                        >No tiene registrada postulantes para esta
                        etapa</template
                      >
                    </v-data-table>
                    <v-btn color="primary" @click="listarPostulantesEtapa2"
                      >Continuar</v-btn
                    >
                    <v-btn class="ml-1" text>Cancelar</v-btn>
                  </v-stepper-content>
                  <!-- Etapa 2-->
                  <v-stepper-step
                    editable
                    :complete="e6 > 2"
                    step="2"
                    :rules="[() => oketapa2]"
                    @click="listarPostulantesEtapa2"
                  >
                    Examen Medico Ocupacional
                    <div class="d-flex">
                      <v-chip class="ma-1" small
                        >Del {{ postulantesetapa2fechainicio }} al
                        {{ postulantesetapa2fechafin }}</v-chip
                      >
                      <v-chip class="ma-1" color="teal darken-3" dark small
                        >Aptos: {{ postulantesetapa2aptos }}</v-chip
                      >
                      <v-chip class="ma-1" color="blue-grey darken-2" dark small
                        >No evaluados:
                        {{ postulantesetapa2noevaluados }}</v-chip
                      >
                      <v-chip
                        class="ma-1"
                        color="red darken-1"
                        text-color="white"
                        small
                        >No aptos: {{ postulantesetapa2noaptos }}</v-chip
                      >
                      <!--<small>Fecha:Inicio</small>-->
                    </div>
                  </v-stepper-step>
                  <!-- Etapa 2 data Table-->
                  <v-stepper-content step="2" class="mb-1">
                    <v-data-table
                      :headers="headeretapa"
                      :items="postulantesetapa2"
                      hide-default-footer
                      class="elevation-1 mt-2 mb-5"
                      dense
                    >
                      <template v-slot:item.acciones="{ item }">
                        <v-btn
                          x-small
                          color="primary"
                          dark
                          :style="textascolumn"
                          @click="actualizarPostulacionByPostualacion(item,2)"
                          >Guardar</v-btn
                        >
                      </template>
                      <template v-slot:item.individuo="{ item }">
                        <small>{{ item.individuo }}</small>
                        <v-chip
                          class="ma-2"
                          x-small
                          dark
                          color="blue-grey darken-4"
                          v-if="item.contratado"
                          >Contratado</v-chip
                        >
                      </template>
                      <template v-slot:item.estado="{ item }">
                        <v-select
                          :items="estados"
                          v-model="item.estado"
                          dense
                          hide-details
                          :disabled="item.contratado"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>{{ item.text }}</v-chip>
                          </template>
                        </v-select>
                      </template>
                      <template v-slot:item.observaciones="{ item }">
                        <v-text-field
                          v-model="item.observaciones"
                          dense
                          auto-grow
                          full-width
                          hide-details
                          class="mb-2"
                        ></v-text-field>
                      </template>
                      <template v-slot:no-data
                        >No tiene registrada postulantes para esta
                        etapa</template
                      >
                    </v-data-table>
                    <v-btn color="primary" @click="listarPostulantesEtapa3"
                      >Continuar</v-btn
                    >
                    <v-btn class="ml-1" text>Cancelar</v-btn>
                  </v-stepper-content>
                  <!-- Etapa 3 -->
                  <v-stepper-step
                    editable
                    :complete="e6 > 3"
                    step="3"
                    :rules="[() => oketapa3]"
                    @click="listarPostulantesEtapa3"
                  >
                    Induccion
                    <div class="d-flex">
                      <v-chip class="ma-1" small
                        >Del {{ postulantesetapa3fechainicio }} al
                        {{ postulantesetapa3fechafin }}</v-chip
                      >
                      <v-chip class="ma-1" color="teal darken-3" dark small
                        >Aptos: {{ postulantesetapa3aptos }}</v-chip
                      >
                      <v-chip class="ma-1" color="blue-grey darken-2" dark small
                        >No evaluados:
                        {{ postulantesetapa3noevaluados }}</v-chip
                      >
                      <v-chip
                        class="ma-1"
                        color="red darken-1"
                        text-color="white"
                        small
                        >No aptos: {{ postulantesetapa3noaptos }}</v-chip
                      >
                      <!--<small>Fecha:Inicio</small>-->
                    </div>
                  </v-stepper-step>
                  <!-- Etapa 3 Data table-->
                  <v-stepper-content step="3" class="mb-1">
                    <v-data-table
                      :headers="headeretapa"
                      :items="postulantesetapa3"
                      hide-default-footer
                      class="elevation-1 mt-2 mb-5"
                      dense
                    >
                      <template v-slot:item.acciones="{ item }">
                        <v-btn
                          x-small
                          color="primary"
                          dark
                          :style="textascolumn"
                          @click="actualizarPostulacionByPostualacion(item,3)"
                          v-if="item.orden <= 6"
                          >Guardar</v-btn
                        >
                      </template>
                      <template v-slot:item.individuo="{ item }">
                        <small>{{ item.individuo }}</small>
                        <v-chip
                          class="ma-2"
                          x-small
                          dark
                          color="blue-grey darken-4"
                          v-if="item.contratado"
                          >Contratado</v-chip
                        >
                      </template>
                      <template v-slot:item.estado="{ item }">
                        <v-select
                          :items="estados"
                          v-model="item.estado"
                          dense
                          hide-details
                          :disabled="item.contratado"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small color>{{ item.text }}</v-chip>
                          </template>
                        </v-select>
                      </template>
                      <template v-slot:item.observaciones="{ item }">
                        <v-text-field
                          v-model="item.observaciones"
                          dense
                          auto-grow
                          full-width
                          hide-details
                          class="mb-2"
                        ></v-text-field>
                      </template>
                      <template v-slot:no-data
                        >No tiene registrada postulantes para esta
                        etapa</template
                      >
                    </v-data-table>
                    <v-btn color="primary" @click="listarPostulantesEtapa4"
                      >Continuar</v-btn
                    >
                    <v-btn class="ml-1" text>Cancelar</v-btn>
                  </v-stepper-content>
                  <!-- Etapa 4 -->
                  <v-stepper-step
                    editable
                    step="4"
                    @click="listarPostulantesEtapa4"
                    :rules="[() => oketapa4]"
                  >
                    Firma de contrato
                    <div class="d-flex">
                      <v-chip class="ma-1" small
                        >Del {{ postulantesetapa4fechainicio }} al
                        {{ postulantesetapa4fechafin }}</v-chip
                      >
                      <v-chip class="ma-1" color="primary" small
                        >Total contratados:
                        {{ postulantesetapa4contratados }}</v-chip
                      >
                      <!--<small>Fecha:Inicio</small>-->
                    </div>
                  </v-stepper-step>
                  <!-- Etapa 4 Data Table-->
                  <v-stepper-content step="4" class="mb-1">
                    <v-data-table
                      :headers="headeretapa"
                      :items="postulantesetapa4"
                      hide-default-footer
                      class="elevation-1 mt-2 mb-5"
                      dense
                    >
                      <template v-slot:item.acciones="{ item }">
                        <v-btn
                          x-small
                          color="primary"
                          dark
                          :style="textascolumn"
                          @click="actualizarPostulacionByPostualacion(item,4)"
                          >Guardar</v-btn
                        >
                      </template>
                      <template v-slot:item.individuo="{ item }">
                        <small>{{ item.individuo }}</small>
                        <v-chip
                          class="ma-2"
                          x-small
                          dark
                          color="blue-grey darken-4"
                          v-if="item.contratado"
                          >Contratado</v-chip
                        >
                      </template>
                      <template v-slot:item.estado="{ item }">
                        <v-select
                          :items="estadoscontrato"
                          v-model="item.estado"
                          dense
                          hide-details
                          :disabled="item.contratado"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>{{ item.text }}</v-chip>
                          </template>
                        </v-select>
                      </template>
                      <template v-slot:item.observaciones="{ item }">
                        <v-text-field
                          v-model="item.observaciones"
                          dense
                          auto-grow
                          full-width
                          hide-details
                          class="mb-2"
                        ></v-text-field>
                      </template>
                      <template v-slot:no-data
                        >No tiene registrada postulantes para esta
                        etapa</template
                      >
                    </v-data-table>
                    <!--<v-btn color="primary" @click="e6 = 1">Continuar</v-btn>
                    <v-btn text>Cancelar</v-btn>-->
                  </v-stepper-content>
                </v-stepper>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Administracion -->
      <v-col
        cols="12"
        md="12"
        sm="12"
        xs="12"
        dense
        class="mx-0 px-0"
        v-if="administracion"
      >
        <v-card mx-auto outlined>
          <v-row class="grey lighten-5">
            <v-col
              cols="12"
              md="12"
              sm="12"
              xs="12"
              dense
              class="d-flex justify-start"
            >
              <v-btn-toggle class="mb-0 pb-0" center>
                <v-btn @click="activaradministracion1">Por requerimiento</v-btn>
                <v-btn @click="activaradministracion2">Por persona</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Administracion por requerimiento -->
            <v-col cols="12" md="12" sm="12" xs="12" v-if="administracion1">
              <v-row>
                <v-col cols="12" md="12" sm="12" xs="12" lg="2" xl="2"></v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" class="justify-center">
                  <v-autocomplete
                    v-model="requerimientoid"
                    :items="listarequerimientos"
                    :search-input.sync="searchrequerimiento"
                    cache-items
                    class="mx-4"
                    flat
                    hide-no-data
                    hide-details
                    label="Buscar requerimiento..."
                    solo-inverted
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  xs="12"
                  lg="2" xl="2"
                  class="d-flex justify-center"
                >
                  <v-btn-toggle>
                    <v-btn @click="editItemReporte">Consultar</v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12"></v-col>
                <v-col cols="12" md="2" sm="12" xs="12"></v-col>
                <v-col cols="12" md="8" sm="12" xs="12">
                  <v-data-table
                    :headers="headerresumenadministracion1"
                    :items="postulantesresumenadministracion1"
                    hide-default-footer
                    class="elevation-1 mt-3"
                  >
                    <template v-slot:item.cubierto="{ item }">
                      <v-chip
                        :color="getColor2(item.cantidad, item.cubierto)"
                        dark
                        >{{ item.cubierto }}</v-chip
                      >
                    </template>
                    <template v-slot:item.porcubrir="{ item }">
                      <v-chip dark>{{
                        diferencia(item.cantidad, item.cubierto)
                      }}</v-chip> </template
                    >-->
                    <template v-slot:no-data
                      >No tiene registrada postulaciones por
                      administrar</template
                    >
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="2" sm="12" xs="12"></v-col>
                <v-col cols="12" md="1" sm="12" xs="12"></v-col>
                <v-col cols="12" md="10" sm="12" xs="12">
                  <v-data-table
                    :headers="headerresumenadministracion2"
                    :items="postulantesresumenadministracion2"
                    hide-default-footer
                    class="elevation-1 mt-3"
                  >
                    <template v-slot:item.noevaluado="{ item }">
                      <v-chip color="blue-grey darken-2" dark>{{
                        item.noevaluado
                      }}</v-chip>
                    </template>
                    <template v-slot:item.apto="{ item }">
                      <v-chip color="teal darken-3" dark>{{
                        item.apto
                      }}</v-chip>
                    </template>
                    <template v-slot:item.noapto="{ item }">
                      <v-chip color="red darken-1" dark>{{
                        item.noapto
                      }}</v-chip>
                    </template>

                    <template v-slot:no-data
                      >No tiene registrada postulaciones por
                      administrar</template
                    >
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="1" sm="12" xs="12"></v-col>
                <v-col cols="12" md="1" sm="12" xs="12"></v-col>
                <v-col cols="12" md="10" sm="12" xs="12">
                  <v-data-table
                    :headers="headerresumenadministracion3"
                    :items="postulantesresumenadministracion3"
                    hide-default-footer
                    class="elevation-1 mt-3"
                  >
                    <template v-slot:item.noevaluado="{ item }">
                      <v-chip color="blue-grey darken-2" dark>{{
                        item.noevaluado
                      }}</v-chip>
                    </template>
                    <template v-slot:item.contratado="{ item }">
                      <v-chip color="primary" dark>{{
                        item.contratado
                      }}</v-chip>
                    </template>
                    <template v-slot:item.nocontratado="{ item }">
                      <v-chip color="red darken-1" dark>{{
                        item.nocontratado
                      }}</v-chip>
                    </template>

                    <template v-slot:no-data
                      >No tiene registrada postulaciones por
                      administrar</template
                    >
                  </v-data-table>
                </v-col>
                <v-col cols="12" md="1" sm="12" xs="12"></v-col>
              </v-row>
            </v-col>
            <!-- Administracion por persona -->
            <v-col cols="12" md="12" sm="12" xs="12" v-if="administracion2">
              <v-card class="mx-auto">
                <v-data-table
                  :headers="headeradministracion2"
                  :items="postulantesadministracion2"
                  :search="searchpostulantesadministracion2"
                  class="elevation-1 mt-3"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title class=".body-2"
                        >Postulaciones por persona</v-toolbar-title
                      >
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="searchpostulantesadministracion2"
                        append-icon="mdi-magnify"
                        label="Busqueda"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-toolbar>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <v-chip :color="getColor(item.estado)" small dark>{{
                      item.estado
                    }}</v-chip>
                  </template>
                  <template v-slot:no-data
                    >No tiene registrada postulaciones por administrar</template
                  >
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!-- Snackbar-->
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{ icon }}</v-icon>
        {{ error }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import FilenameOption from '../views/excel/components/FilenameOption'
import AutoWidthOption from '../views/excel/components/AutoWidthOption'
import BookTypeOption from '../views/excel/components/BookTypeOption'
import { parseTime } from '../utils'
//Nuestro codigo Vue
export default {
  data: () => ({
    //==================== Stepper
    e6: 1,
    //==================== General
    date: new Date().toISOString().substr(0, 10),
    snackbar: false,
    match: true,
    postulacion: false,
    seguimiento: false,
    administracion: false,
    administracion1: true,
    administracion2: false,
    cuallistar: "",
    icon: "mdi-thumb-up",
    color: "#2A3B4D",
    error: null,
    errorMessages: "",
    formProgramacionHasErrors: false,
    searchpostulantesadministracion1: "",
    searchpostulantesadministracion2: "",
    searchInput: null,
    overlay: false,
    overlay2: false,
    dentrodeplazo: false,
    fueradeplazo: false,
    textascolumn0: {
      width: "50px",
    },
    textascolumn: {
      width: "120px",
    },
    textascolumn2: {
      width: "200px",
    },
    selectascolumn: {
      width: "150px",
    },
    //================= Programacion
    etapa1: "Revisión de CV Documetado",
    etapa1duracion: 7,
    etapa1fecha_inicio: "",
    etapa1fecha_fin: "",
    etapa2: "Examen médico ocupacional",
    etapa2duracion: 7,
    etapa2fecha_inicio: "",
    etapa2fecha_fin: "",
    etapa3: "Inducción",
    etapa3duracion: 7,
    etapa3fecha_inicio: "",
    etapa3fecha_fin: "",
    etapa4: "Firma de contrato",
    etapa4duracion: 1,
    etapa4fecha_inicio: "",
    etapa4fecha_fin: "",
    //==================== Requerimiento
    searchrequerimiento: "",
    sexos: [
      { text: "Varon", value: "MA" },
      { text: "Mujer", value: "FE" },
      { text: "Ambos", value: "MA,FE" },
    ],
    editedIndexrequerimiento: -1,
    requerimientoid: "",
    requerimientoid2: "",
    requerimientodenominacion: "",
    requerimientofecha_inicio: "",
    requerimientofecha_fin: "",
    requerimientoperfil: "",
    requerimientoempresa: "",
    areaid: "",
    tipos_empresa: [],
    tipos_empresas: [
      { tipos_empresa: "Principal" },
      { tipos_empresa: "Contratista" },
    ],
    requerimiento_estado: "",
    requerimientocantidad: 0,
    requerimientosexo: "",
    requerimientoedadminima: "",
    requerimiento_añosexperiencia: "",
    listarequerimientos: [],
    listarequerimientos2: [],
    requerimientos: [],

    //==================== Experiencia
    experiencia_principal: [],
    experiencias_principal: [],
    //==================== Fechas
    fecha_inicio: "",
    fecha_fin: "",
    //==================== Educacion
    clasificaciones_locacion: [],
    clasificacion_locacion: [],
    //==================== RubroEmpresa
    rubro_empresa: [],
    rubro_empresas: [],
    //==================== TipoLocacion
    requerimiento_tipolocacion: [],
    requerimiento_tiposlocacion: [],
    //==================== Conocimiento
    conocimiento_principal: [],
    conocimientos_principal: [],
    //==================== Postulantes
    contratosempresas: [],
    headercontratosempresas: [
      { text: "Empresa", value: "razonsocial", align: "start", width: "150px" },
      { text: "RUC", value: "ruc", align: "center" },
      { text: "Giro Comercial", value: "giro_comercial", align: "center" },
      { text: "Fecha Inicio", value: "fecha_inicio", align: "center" },
      { text: "Fecha Fin", value: "fecha_fin", align: "center" },
      { text: "Monto", value: "monto_contrato", align: "start" },
      { text: "Observaciones", value: "servicio_observaciones", align: "start" },
      { text: "Locacion", value: "locacion", align: "start" },
      { text: "Licencia", value: "licencia", align: "center" },
    ],
    postulanteselegidos: [],
    headerpostulanteselegidos: [
      { text: "Nombre", value: "individuo", align: "start" },
      { text: "Acciones", value: "acciones", align: "center" },
    ],
    selectedRows: [],
    //==================== Programacion
    programaciones: [],
    headerprogramacion: [
      {
        text: "Etapa de postulación",
        value: "etapa",
        align: "start",
        width: "200px",
      },
      // { text: "Duración", value: "dias", align: "center",width:"50px"},
      {
        text: "Fecha inicio",
        value: "fecha_inicio",
        align: "center",
        width: "120px",
      },
      {
        text: "Fecha fin",
        value: "fecha_fin",
        align: "center",
        width: "120px",
      },
      { text: "Acciones", value: "acciones", align: "center", width: "120px" },
    ],
    //==================== postulantesetapa
    etapa: "",
    etapas: [
      { text: "REVISION DE CV", value: "REVISION DE CV" },
      { text: "ENTREVISTA", value: "ENTREVISTA" },
      { text: "EVALUACION TECNICA", value: "EVALUACION TECNICA" },
      { text: "REV. CV DOCUMENTADO", value: "REV. CV DOCUMENTADO" },
      { text: "REV. ANTECEDENTES", value: "REV. ANTECEDENTES" },
      { text: "EXAMEN MEDICO OCUPACIONAL", value: "EXAMEN MEDICO OCUPACIONAL" },
      { text: "INDUCCION", value: "INDUCCION" },
    ],
    postulantesetapa1: [],
    headeretapa: [
      {
        text: "Postulante seleccionado",
        value: "individuo",
        align: "start",
        width: "250px",
      },
      { text: "Evaluacion", value: "estado", align: "center", width: "50px" },
      {
        text: "Observacion",
        value: "observaciones",
        align: "start",
        width: "250px",
      },
      { text: "Acciones", value: "acciones", align: "center", width: "100px" },
    ],
    postulantesetapa2: [],
    postulantesetapa3: [],
    postulantesetapa4: [],
    postulantesetapa1fechainicio: "",
    postulantesetapa1fechafin: "",
    postulantesetapa1aptos: 0,
    postulantesetapa1noaptos: 0,
    postulantesetapa1noevaluados: 0,
    postulantesetapa2fechainicio: "",
    postulantesetapa2fechafin: "",
    postulantesetapa2aptos: 0,
    postulantesetapa2noaptos: 0,
    postulantesetapa2noevaluados: 0,
    postulantesetapa3fechainicio: "",
    postulantesetapa3fechafin: "",
    postulantesetapa3aptos: 0,
    postulantesetapa3noaptos: 0,
    postulantesetapa3noevaluados: 0,
    postulantesetapa4fechainicio: "",
    postulantesetapa4fechafin: "",
    postulantesetapa4contratados: 0,
    postulantesetapa4nocontratados: 0,

    //======================= Reportes
    postulantesresumenadministracion1: [],
    headerresumenadministracion1: [
      {
        text: "Requerimiento",
        value: "denominacion",
        align: "start",
        width: "250px",
      },
      { text: "Cupos", value: "cantidad", align: "center" },
      { text: "Cupos cubiertos", value: "cubierto", align: "center" },
      { text: "Cupos por cubrir", value: "porcubrir", align: "center" },
    ],
    postulantesresumenadministracion2: [],
    headerresumenadministracion2: [
      {
        text: "Requerimiento",
        value: "denominacion",
        align: "start",
        width: "250px",
      },
      {
        text: "Etapa",
        value: "etapa",
        align: "start",
        width: "150px",
      },
      { text: "No evaluado(s)", value: "noevaluado", align: "center" },
      { text: "Apto(s)", value: "apto", align: "center" },
      { text: "No apto (s)", value: "noapto", align: "center" },
    ],
    postulantesresumenadministracion3: [],
    headerresumenadministracion3: [
      {
        text: "Requerimiento",
        value: "denominacion",
        align: "start",
        width: "250px",
      },
      {
        text: "Etapa",
        value: "etapa",
        align: "start",
        width: "150px",
      },
      { text: "No evaluado(s)", value: "noevaluado", align: "center" },
      { text: "Contratado(s)", value: "contratado", align: "center" },
      { text: "No contratado (s)", value: "nocontratado", align: "center" },
    ],
    postulantesadministracion2: [],
    headeradministracion2: [
      { text: "Requerimiento", value: "denominacion", align: "start" },
      { text: "Cupos", value: "cantidad", align: "center" },
      { text: "Etapa", value: "etapa", align: "center" },
      { text: "Fecha inicio", value: "fecha_inicio", align: "center" },
      { text: "Fecha fin", value: "fecha_fin", align: "center" },
      { text: "Persona", value: "individuo", align: "start" },
      { text: "Evaluacion", value: "estado", align: "center" },
    ],
    estados: [
      { text: "NO EVALUADO", value: "NO EVALUADO" },
      { text: "APTO", value: "APTO" },
      { text: "NO APTO", value: "NO APTO" },
    ],
    estadoscontrato: [
      { text: "NO CONTRATADO", value: "NO CONTRATADO" },
      { text: "CONTRATADO", value: "CONTRATADO" },
    ],
    //========================== Contrato
    empleadoid: "",
    experienciaid: "",
    individuoid: "",
    //==================== Filtros y validacion
    chktipoempresa: false,
    chktipolocacion: false,
    chkclocacion: false,
    chktrabajando: false,
    chkfechas: false,
    chkmonto: false,
    chkrubroempresa: false,
    valida: 0,
    validamensaje: [],
    
    montoslider: [0, 100],
    listaContratosExportar: [],
    listLoading: true,
    downloadLoading: false,
    filename: '',
    autoWidth: true,
    bookType: 'xlsx'
  }),
  components: {
    VueRangeSlider
  },
  //==================== Created
  created() {
    let me = this;
    this.selectRequerimiento();
    this.selectRequerimiento2();
    this.selectTipoLocacion();
    this.selectEducacionPrincipal();
    this.selectExperienciaPrincipal();
    this.selectConocimientoPrincipal();
    this.min = 0
    this.max = 100000
    this.enableCross = false
    this.tooltipMerge = false
    this.formatter = value => `S/ ${value}`
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },
  //==================== Computed
  computed: {
    form1() {
      return {
        etapa1fecha_inicio: this.etapa1fecha_inicio,
        etapa1fecha_fin: this.etapa1fecha_fin,
        etapa1duracion: this.etapa1duracion,
        etapa2fecha_inicio: this.etapa2fecha_inicio,
        etapa2fecha_fin: this.etapa2fecha_fin,
        etapa2duracion: this.etapa2duracion,
        etapa3fecha_inicio: this.etapa3fecha_inicio,
        etapa3fecha_fin: this.etapa3fecha_fin,
        etapa3duracion: this.etapa3duracion,
        etapa4fecha_inicio: this.etapa4fecha_inicio,
        etapa4fecha_fin: this.etapa4fecha_fin,
        etapa4duracion: this.etapa4duracion,
        /*etapa5fecha_inicio: this.etapa5fecha_inicio,
        etapa5fecha_fin: this.etapa5fecha_fin,
        etapa5duracion: this.etapa5duracion,
        etapa6fecha_inicio: this.etapa6fecha_inicio,
        etapa6fecha_fin: this.etapa6fecha_fin,
        etapa6duracion: this.etapa6duracion,
        etapa7fecha_inicio: this.etapa7fecha_inicio,
        etapa7fecha_fin: this.etapa7fecha_fin,
        etapa7duracion: this.etapa7duracion,
        etapa8fecha_inicio: this.etapa8fecha_inicio,
        etapa8fecha_fin: this.etapa8fecha_fin,
        etapa8duracion: this.etapa8duracion,*/
      };
    },
    seleccionadoscantidad() {
      return this.selectedRows.length;
    },
    postulanteselegidoscantidad() {
      return this.postulanteselegidos.length;
    },
    oketapa1() {
      if (
        this.postulantesetapa1noevaluados > 0 ||
        this.requerimientocantidad > this.postulantesetapa1aptos
      )
        return false;
      else return true;
    },
    oketapa2() {
      if (
        this.postulantesetapa2noevaluados > 0 ||
        this.requerimientocantidad > this.postulantesetapa2aptos
      )
        return false;
      else return true;
    },
    oketapa3() {
      if (
        this.postulantesetapa3noevaluados > 0 ||
        this.requerimientocantidad > this.postulantesetapa3aptos
      )
        return false;
      else return true;
    },
    oketapa4() {
      if (
        this.postulantesetapa4noevaluados > 0 ||
        this.requerimientocantidad > this.postulantesetapa4aptos
      )
        return false;
      else return true;
    },
  },

  //==================== Metodos
  methods: {
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.formProgramacionHasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;
        this.$refs[f].validate(true);
      });
    },
    mostrarFecha(fecha) {
      var day = ("0" + fecha.getDate()).slice(-2);
      var month = ("0" + (fecha.getMonth() + 1)).slice(-2);
      var today = fecha.getFullYear() + "-" + month + "-" + day;
      return today;
    },
    generarFechaFin1() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa1fecha_inicio));
      if (this.isDate(this.etapa1fecha_inicio)) {
        var d = new Date(this.etapa1fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa1duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa1fecha_fin = this.mostrarFecha(d);
        //Reiniciamos el ciclo desde el 2
        this.generarFechaInicio2();
      }
    },
    generarFechaInicio2() {
      if (this.isDate(this.etapa1fecha_fin)) {
        var d = new Date(this.etapa1fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa2fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin2();
      }
    },
    generarFechaFin2() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa2fecha_inicio));
      if (this.isDate(this.etapa2fecha_inicio)) {
        var d = new Date(this.etapa2fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa2duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa2fecha_fin = this.mostrarFecha(d);
        this.generarFechaInicio3();
      }
    },
    generarFechaInicio3() {
      if (this.isDate(this.etapa2fecha_fin)) {
        var d = new Date(this.etapa2fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa3fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin3();
      }
    },
    generarFechaFin3() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa3fecha_inicio));
      if (this.isDate(this.etapa3fecha_inicio)) {
        var d = new Date(this.etapa3fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa3duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa3fecha_fin = this.mostrarFecha(d);
        this.generarFechaInicio4();
      }
    },
    generarFechaInicio4() {
      if (this.isDate(this.etapa3fecha_fin)) {
        var d = new Date(this.etapa3fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa4fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin4();
      }
    },
    generarFechaFin4() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa4fecha_inicio));
      if (this.isDate(this.etapa4fecha_inicio)) {
        var d = new Date(this.etapa4fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa4duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa4fecha_fin = this.mostrarFecha(d);
        this.verificarFechaFinal();
        //this.generarFechaInicio5();
      }
    },
    /*generarFechaInicio5() {
      if (this.isDate(this.etapa4fecha_fin)) {
        var d = new Date(this.etapa4fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa5fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin5();
      }
    },
    generarFechaFin5() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa5fecha_inicio));
      if (this.isDate(this.etapa5fecha_inicio)) {
        var d = new Date(this.etapa5fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa5duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa5fecha_fin = this.mostrarFecha(d);
        this.generarFechaInicio6();
      }
    },
    generarFechaInicio6() {
      if (this.isDate(this.etapa5fecha_fin)) {
        var d = new Date(this.etapa5fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa6fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin6();
      }
    },
    generarFechaFin6() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa6fecha_inicio));
      if (this.isDate(this.etapa6fecha_inicio)) {
        var d = new Date(this.etapa6fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa6duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa6fecha_fin = this.mostrarFecha(d);
        this.generarFechaInicio7();
      }
    },
    generarFechaInicio7() {
      if (this.isDate(this.etapa6fecha_fin)) {
        var d = new Date(this.etapa6fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa7fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin7();
      }
    },
    generarFechaFin7() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa7fecha_inicio));
      if (this.isDate(this.etapa7fecha_inicio)) {
        var d = new Date(this.etapa7fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa7duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa7fecha_fin = this.mostrarFecha(d);
        this.generarFechaInicio8();
      }
    },
    generarFechaInicio8() {
      if (this.isDate(this.etapa7fecha_fin)) {
        var d = new Date(this.etapa7fecha_fin + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.etapa8fecha_inicio = this.mostrarFecha(d);
        this.generarFechaFin8();
      }
    },
    generarFechaFin8() {
      console.log("Entra a generar fecha fin");
      console.log(this.isDate(this.etapa8fecha_inicio));
      if (this.isDate(this.etapa8fecha_inicio)) {
        var d = new Date(this.etapa8fecha_inicio + "T00:00:00");
        console.log(d);
        d.setDate(d.getDate() + Number(this.etapa8duracion) - 1);
        console.log(d);
        console.log(this.mostrarFecha(d));
        this.etapa8fecha_fin = this.mostrarFecha(d);
        this.verificarFechaFinal();
      }
    },*/
    verificarFechaFinal() {
      if (this.isDate(this.etapa4fecha_fin)) {
        var firmacontrato = new Date(this.etapa4fecha_fin + "T00:00:00");
        var inicioreque = new Date(
          this.requerimientofecha_inicio + "T00:00:00"
        );
        if (inicioreque >= firmacontrato) {
          this.dentrodeplazo = true;
          this.fueradeplazo = false;
        } else {
          this.dentrodeplazo = false;
          this.fueradeplazo = true;
        }
      } else {
        this.dentrodeplazo = false;
        this.fueradeplazo = false;
      }
    },
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },

    //==================== Requerimiento
    limpiarRequerimiento() {
      this.requerimientofecha_inicio = "";
      this.requerimientofecha_fin = "";
      this.areaid = "";
      this.requerimiento_tipo = [];
      this.requerimiento_estado = "";
      this.requerimientocantidad = 0;
      this.editedIndexrequerimiento = -1;
    },
    //Lista los requerimientos que estan abiertos y cerrados
    selectRequerimiento() {
      let me = this;
      var Array = [];
      me.listarequerimientos = [];
      let rol = localStorage.getItem("rol");
      let idempresa = localStorage.getItem("empresa");
      //if (rol == "CONTRATISTA" || rol == "RRCC" || rol == "DHO") {
      if (rol == "CONTRATISTA") {
        axios
          .get("api/Requerimientos/SelectEmpresa/" + idempresa)
          .then(function (response) {
            Array = response.data;
            Array.map(function (x) {
              me.listarequerimientos.push({
                text: x.denominacion,
                value: x.idrequerimiento,
              });
            });
          })
          .catch(function (error) {
            //Porahora lo mostramos en consola
            console.log(error);
          });
      } else {
        axios
          .get("api/Requerimientos/Select")
          .then(function (response) {
            Array = response.data;
            Array.map(function (x) {
              me.listarequerimientos.push({
                text: x.denominacion,
                value: x.idrequerimiento,
              });
            });
          })
          .catch(function (error) {
            //Porahora lo mostramos en consola
            console.log(error);
          });
      }
    },
    // Solo lista los requerimientos que no estan cerrados
    selectRequerimiento2() {
      let me = this;
      var Array = [];
      me.listarequerimientos2 = [];
      let rol = localStorage.getItem("rol");
      let idempresa = localStorage.getItem("empresa");
      //if (rol == "CONTRATISTA" || rol == "RRCC" || rol == "DHO") {
      if (rol == "CONTRATISTA") {
        axios
          .get("api/Requerimientos/Select2Empresa/" + idempresa)
          .then(function (response) {
            Array = response.data;
            Array.map(function (x) {
              me.listarequerimientos2.push({
                text: x.denominacion,
                value: x.idrequerimiento,
              });
            });
          })
          .catch(function (error) {
            //Porahora lo mostramos en consola
            console.log(error);
          });
      } else {
        axios
          .get("api/Requerimientos/Select2")
          .then(function (response) {
            Array = response.data;
            Array.map(function (x) {
              me.listarequerimientos2.push({
                text: x.denominacion,
                value: x.idrequerimiento,
              });
            });
          })
          .catch(function (error) {
            //Porahora lo mostramos en consola
            console.log(error);
          });
      }
    },
    editItem() {
      let me = this;
      //me.overlay=true;
      var Array = [];
      me.requerimiento_tipolocacion = [];
      me.requerimiento_tipo = [];
      me.dentrodeplazo = false;
      me.fueradeplazo = false;
      me.LimpiarProgramacion();
      axios
        .get("api/Requerimientos/Mostrar/" + me.requerimientoid)
        .then(function (response) {
          me.requerimientoid = response.data.idrequerimiento;
          me.requerimientodenominacion = response.data.denominacion;
          me.requerimientocantidad = response.data.cantidad;
          me.requerimientosexo = response.data.sexo;
          me.requerimientoperfil = response.data.perfil;
          me.requerimientoempresa = response.data.empresa;
          me.areaid = response.data.idarea;
          me.requerimientofecha_inicio = response.data.fecha_inicio;
          me.requerimientofecha_fin = response.data.fecha_fin;
          me.requerimientoedadminima = response.data.edadminima;
          me.requerimiento_tipolocacion.push(response.data.tipo_educacion);
          me.requerimiento_añosexperiencia = response.data.años_experiencia;
          me.requerimiento_tipo.push(response.data.tipo_postulante);
          me.listarEducacion();
          me.listarExperiencia();
          me.listarConocimiento();
          me.ListarProgramaciones();
          me.ListarPostulantesElegidos();
          me.listarPostulantesEtapa1();
          me.listarPostulantesEtapa2();
          me.listarPostulantesEtapa3();
          me.listarPostulantesEtapa4();
          me.e6 = 1;
          me.ListarProgramacionEtapa1();
          me.ListarProgramacionEtapa2();
          me.ListarProgramacionEtapa3();
          me.ListarProgramacionEtapa4();
          me.limpiarPostulantes();
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
      //me.overlay=false;
    },
    editItem2() {
      let me = this;
      var Array = [];
      me.requerimiento_tipolocacion = [];
      me.requerimiento_tipo = [];
      axios
        .get("api/Requerimientos/Mostrar/" + me.requerimientoid2)
        .then(function (response) {
          me.requerimientoid = response.data.idrequerimiento;
          me.requerimientodenominacion = response.data.denominacion;
          me.requerimientocantidad = response.data.cantidad;
          me.requerimientosexo = response.data.sexo;
          me.requerimientoperfil = response.data.perfil;
          me.requerimientoempresa = response.data.empresa;
          me.areaid = response.data.idarea;
          me.requerimientofecha_inicio = response.data.fecha_inicio;
          me.requerimientofecha_fin = response.data.fecha_fin;
          me.requerimientoedadminima = response.data.edadminima;
          me.requerimiento_tipolocacion.push(response.data.tipo_educacion);
          me.requerimiento_añosexperiencia = response.data.años_experiencia;
          me.requerimiento_tipo.push(response.data.tipo_postulante);
          me.listarEducacion();
          me.listarExperiencia();
          me.listarConocimiento();
          me.limpiarPostulantes();
          me.selectExperienciaPrincipal();
          me.selectEducacionPrincipal();
          me.selectConocimientoPrincipal();
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    //==================== Tipo postulante
    remove4(item) {
      const index4 = this.tipos_empresa.indexOf(item.tipos_empresa);
      if (index4 >= 0) this.tipos_empresa.splice(index4, 1);
    },
    //==================== Tipo educacion
    remove5(item) {
      //console.log("Remove 5 " + this.requerimiento_tipolocacion.toString());
      const index5 = this.requerimiento_tipolocacion.indexOf(
        item.tipo_locacion
      );
      if (index5 >= 0) this.requerimiento_tipolocacion.splice(index5, 1);
    },
    //==================== Filtro Educacion
    remove(item) {
      //console.log("Remove 1 " + this.clasificacion_locacion.toString());
      const index = this.clasificacion_locacion.indexOf(item.clasificacion);
      //console.log(index);
      if (index >= 0) this.clasificacion_locacion.splice(index, 1);
      //console.log("Remove 1 salida" + this.clasificacion_locacion.toString());
    },
    customFilterCLocacion(item, queryText, itemText) {
      const textOne = item.clasificacion.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    //==================== Filtro Experiencia
    remove2(item) {
      const index2 = this.experiencia_principal.indexOf(item.puesto);
      if (index2 >= 0) this.experiencia_principal.splice(index2, 1);
    },
    customFilterExperiencia(item, queryText, itemText) {
      const textOne = item.experiencia.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    //==================== Filtro Conocimiento
    remove3(item) {
      const index3 = this.conocimiento_principal.indexOf(item.conocimiento);
      if (index3 >= 0) this.conocimiento_principal.splice(index3, 1);
    },
    //==================== Educacion
    selectTipoLocacion() {
      let me = this;
      var Array = [];
      me.requerimiento_tiposlocacion = [];
      axios
        .get("api/TipoLocacion")
        .then(function (response) {
          me.requerimiento_tiposlocacion = response.data;
          //console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectEducacionPrincipal() {
      let me = this;
      var Array = [];
      me.clasificaciones_locacion = [];
      axios
        .get("api/MatchEducaciones")
        .then(function (response) {
          me.clasificaciones_locacion = response.data;
          //console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarEducacion() {
      let me = this;
      axios
        .get(
          "api/EducacionsPerfiles/GetEducacionsByRequerimiento/?requerimientoId=" +
            me.requerimientoid
        )
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          //educaciones2= response.data;
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].denominacion);
          }
          me.clasificacion_locacion = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //==================== Experiencia
    selectExperienciaPrincipal() {
      let me = this;
      var Array = [];
      me.experiencias_principal = [];
      axios
        .get("api/MatchExperiencias")
        .then(function (response) {
          me.experiencias_principal = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarExperiencia() {
      let me = this;
      axios
        .get(
          "api/ExperienciasPerfiles/GetExperienciasByRequerimiento/?requerimientoId=" +
            me.requerimientoid.toString()
        )
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          var res = [];
          for (var i in obj) {
            res.push(obj[i].puesto);
          }
          me.experiencia_principal = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //==================== Conocimiento
    selectConocimientoPrincipal() {
      let me = this;
      var Array = [];
      me.conocimiento_principal = [];
      axios
        .get("api/MatchConocimientos")
        .then(function (response) {
          me.conocimientos_principal = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarConocimiento() {
      let me = this;
      axios
        .get(
          "api/ConocimientosPerfiles/GetConocimientosByRequerimiento/?requerimientoId=" +
            me.requerimientoid
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].denominacion);
          }
          me.conocimiento_principal = res;
          console.log("Conocimientos" + me.conocimiento_principal.toString());
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //==================== Validacion y menu
    activarmatch() {
      this.match = true;
      this.postulacion = false;
      this.seguimiento = false;
      this.administracion = false;
      this.requerimientoid2 = this.requerimientoid;
      this.editItem2();
      //this.selectRequerimiento2();
    },
    activarpostulacion() {
      this.match = false;
      this.postulacion = true;
      this.seguimiento = false;
      this.administracion = false;
      this.editItem();
      //this.selectRequerimiento();
    },
    activarseguimiento() {
      this.match = false;
      this.postulacion = false;
      this.seguimiento = true;
      this.administracion = false;
      this.error = "";
      this.e6 = 1;
      if (this.requerimientoid != "") {
        this.listarPostulantesEtapa1();
      }
      //this.editItem();
      //this.selectRequerimiento();
    },
    activaradministracion() {
      this.match = false;
      this.postulacion = false;
      this.seguimiento = false;
      this.administracion = true;
      this.activaradministracion1();
      //this.editItem();
      //this.selectRequerimiento();
    },
    activaradministracion1() {
      this.administracion1 = true;
      this.administracion2 = false;
      this.ListarPostulantesAdministracion1();
    },
    activaradministracion2() {
      this.administracion1 = false;
      this.administracion2 = true;
      this.ListarPostulantesAdministracion2();
    },
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    //==================== Individuo
    activarCondicionRequerimiento(id) {
      let me = this;
      axios
        .put("/api/Individuos/ActivarRequerimiento/" + id, {})
        .then(function (response) {
          me.reiniciarListadoPostulantes();
          console.log("Activada la condicionrequerimiento");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivarCondicionRequerimiento(id) {
      let me = this;
      axios
        .put("/api/Individuos/DesactivarRequerimiento/" + id, {})
        .then(function (response) {
          console.log("Desactivada la condicionrequerimiento");
          me.reiniciarListadoPostulantes();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //==================== Postulantes
    //Metodo para llamar seleccionar el row en el que se hizo click
    rowClicked(row) {
      this.toggleSelection(row.idindividuo);
      console.log(row);
    },
    //Metodo para aplicar el toogle en caso de selección
    toggleSelection(keyID) {
      if (this.selectedRows.includes(keyID)) {
        this.selectedRows = this.selectedRows.filter(
          (selectedKeyID) => selectedKeyID !== keyID
        );
      } else {
        this.selectedRows.push(keyID);
      }
    },
    MostrarSelects() {
      console.log("Mostrar seleccionados" + JSON.stringify(this.selected));
    },
    getColor(estado) {
      if (estado == "NO EVALUADO") return "blue-grey darken-2";
      else if (estado == "NO APTO" || estado == "NO CONTRATADO")
        return "red darken-1";
      else if (estado == "CONTRATADO") return "primary";
      else return "teal darken-3";
    },
    getColor2(total, cubierto) {
      if (cubierto < total) return "red darken-1";
      else return "teal darken-3";
    },
    diferencia(total, cubierto) {
      return Number(total - cubierto);
    },
    ListarPostulantes() {
      let me = this;
      me.cuallistar = "NORMAL";
      /*console.log("Entra a postular");
      console.log("Edad: " + Number(me.requerimientoedadminima));
      console.log("Sexo: " + me.requerimientosexo);
      console.log("Postulante: " + me.requerimiento_tipo.toString());
      console.log("Tipo Educacion: " + me.requerimiento_tipolocacion.toString());
      console.log("Educacion: " + me.clasificacion_locacion.toString());
      console.log("Puesto: " + me.experiencia_principal.toString());
      console.log("Experiencia: " + Number(me.requerimiento_añosexperiencia));
      console.log("Conocimiento: " + me.conocimiento_principal.toString());
      console.log("f_educacion: " + me.chkclocacion.toString());
      console.log("f_experiencia: " + me.chkfechas.toString());
      console.log("f_conocimiento: " + me.chkmonto.toString());*/
      
      axios
        .post("api/FiltrosContratos/ListarContratos", {
          tipo_empresa: me.tipos_empresa.join(","),
          sector: me.rubro_empresa.join(","),
          tipo_locacion: me.requerimiento_tipolocacion.join(","),
          clasificacion: me.clasificacion_locacion.join(","),
          fecha_inicio: me.fecha_inicio,
          fecha_fin: me.fecha_fin,
          monto_contrato_i: Number(me.montoslider[0]),
          monto_contrato_f: Number(me.montoslider[1]),
          f_tipo_empresa: me.chktipoempresa,
          f_tipo_locacion: me.chktipolocacion,
          f_clasificacion: me.chkclocacion,
          f_fechas: me.chkfechas,
          f_monto_contrato: me.chkmonto,
          f_sector: me.chkrubroempresa,
          /*edad: Number(me.requerimientoedadminima),
          sexo: me.requerimientosexo,
          tipo_postulante: me.requerimiento_tipo.join(","),
          tipo_educacion: me.requerimiento_tipolocacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          experiencia: me.experiencia_principal.join(","),
          conocimiento: me.conocimiento_principal.join(","),
          f_educacion: me.chkclocacion,
          f_experiencia: me.chkfechas,
          f_conocimiento: me.chkmonto,
          f_gradoacademico: me.chktipolocacion,
          f_trabajando: me.chktrabajando,
          años_experiencia: Number(me.requerimiento_añosexperiencia),
          */
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          me.contratosempresas = [];
          var res = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.contratosempresas = res;
          if (me.contratosempresas.length > 0) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error =
              "Búsqueda exitosa. Se encontraron " +
              me.contratosempresas.length +
              " posibles contratos.";
            me.snackbar = true;
          } else {
            me.color = "#2A3B4D";
            me.icon = "mdi-information";
            me.error =
              "Búsqueda exitosa. Lamentablemente no se encontraron contratos, pruebe cambiando los filtros de busqueda por favor.";
            me.snackbar = true;
          }
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;
        });

    },
    ListarPostulantes2() {
      let me = this;
      me.cuallistar = "NORMAL";
      /*console.log("Entra a postular");
      console.log("Edad: " + Number(me.requerimientoedadminima));
      console.log("Sexo: " + me.requerimientosexo);
      console.log("Postulante: " + me.requerimiento_tipo.toString());
      console.log("Tipo Educacion: " + me.requerimiento_tipolocacion.toString());
      console.log("Educacion: " + me.clasificacion_locacion.toString());
      console.log("Puesto: " + me.experiencia_principal.toString());
      console.log("Experiencia: " + Number(me.requerimiento_añosexperiencia));
      console.log("Conocimiento: " + me.conocimiento_principal.toString());
      console.log("f_educacion: " + me.chkclocacion.toString());
      console.log("f_experiencia: " + me.chkfechas.toString());
      console.log("f_conocimiento: " + me.chkmonto.toString());*/
      axios
        .post("api/Individuos/ListarPostulaciones2", {
          edad: Number(me.requerimientoedadminima),
          sexo: me.requerimientosexo,
          tipo_postulante: me.requerimiento_tipo.join(","),
          tipo_educacion: me.requerimiento_tipolocacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          experiencia: me.experiencia_principal.join(","),
          conocimiento: me.conocimiento_principal.join(","),
          f_educacion: me.chkclocacion,
          f_experiencia: me.chkfechas,
          f_conocimiento: me.chkmonto,
          f_gradoacademico: me.chktipolocacion,
          f_trabajando: me.chktrabajando,
          años_experiencia: Number(me.requerimiento_añosexperiencia),
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          me.postulantes = [];
          var res = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.postulantes = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    ListarPostulantesVecinos() {
      let me = this;
      me.cuallistar = "VECINOS";
      /*
      console.log("Entra a postular");
      console.log("Edad: " + Number(me.requerimientoedadminima));
      console.log("Sexo: " + me.requerimientosexo);
      console.log("Postulante: " + me.requerimiento_tipo);
      console.log("Tipo Educacion: " + me.requerimiento_tipolocacion);
      console.log("Educacion: " + me.clasificacion_locacion.toString());
      console.log("Puesto: " + me.experiencia_principal.toString());
      console.log("Experiencia: " + Number(me.requerimiento_añosexperiencia));
      console.log("Conocimiento: " + me.conocimientos_principal.toString());
      */
      axios
        .post("api/Individuos/ListarPostulaciones3", {
          edad: Number(me.requerimientoedadminima),
          sexo: me.requerimientosexo,
          tipo_postulante: me.requerimiento_tipo.join(","),
          tipo_educacion: me.requerimiento_tipolocacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          experiencia: me.experiencia_principal.join(","),
          conocimiento: me.conocimiento_principal.join(","),
          f_educacion: me.chkclocacion,
          f_experiencia: me.chkfechas,
          f_conocimiento: me.chkmonto,
          f_gradoacademico: me.chktipolocacion,
          f_trabajando: me.chktrabajando,
          años_experiencia: Number(me.requerimiento_añosexperiencia),
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          console.log("POSTULANTES VECINOS: " + JSON.stringify(response.data));
          var res = [];
          me.postulantes = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.postulantes = res;
          if (me.postulantes.length > 0) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error =
              "Match exitoso. Se encontraron " +
              me.postulantes.length +
              " posibles postulantes";
            me.snackbar = true;
          } else {
            me.color = "#2A3B4D";
            me.icon = "mdi-information";
            me.error =
              "Match exitoso. Lamentablemente no se encontraron postulantes, pruebe cambiando los filtros de busqueda por favor.";
            me.snackbar = true;
          }
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;
        });
    },
    ListarPostulantesVecinos2() {
      let me = this;
      me.cuallistar = "VECINOS";
      /*
      console.log("Entra a postular");
      console.log("Edad: " + Number(me.requerimientoedadminima));
      console.log("Sexo: " + me.requerimientosexo);
      console.log("Postulante: " + me.requerimiento_tipo);
      console.log("Tipo Educacion: " + me.requerimiento_tipolocacion);
      console.log("Educacion: " + me.clasificacion_locacion.toString());
      console.log("Puesto: " + me.experiencia_principal.toString());
      console.log("Experiencia: " + Number(me.requerimiento_añosexperiencia));
      console.log("Conocimiento: " + me.conocimientos_principal.toString());
      */
      axios
        .post("api/Individuos/ListarPostulaciones3", {
          edad: Number(me.requerimientoedadminima),
          sexo: me.requerimientosexo,
          tipo_postulante: me.requerimiento_tipo.join(","),
          tipo_educacion: me.requerimiento_tipolocacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          educacion: me.clasificacion_locacion.join(","),
          experiencia: me.experiencia_principal.join(","),
          conocimiento: me.conocimiento_principal.join(","),
          f_educacion: me.chkclocacion,
          f_experiencia: me.chkfechas,
          f_conocimiento: me.chkmonto,
          f_gradoacademico: me.chktipolocacion,
          f_trabajando: me.chktrabajando,
          años_experiencia: Number(me.requerimiento_añosexperiencia),
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          console.log("POSTULANTES VECINOS: " + JSON.stringify(response.data));
          var res = [];
          me.postulantes = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.postulantes = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    limpiarPostulantes() {
      let me = this;
      me.postulantes = [];
    },
    savePostulantes() {
      if (this.selectedRows.length > 0) {
        console.log("Entra al foreach");
        this.selectedRows.forEach((element) =>
          this.savePostulante(
            element,
            "REVISION DE CV DOCUMENTADO",
            "NO EVALUADO",
            1,
            true,
            true
          )
        );
        this.selectedRows.forEach((element) =>
          this.savePostulante(
            element,
            "EXAMEN MEDICO OCUPACIONAL",
            "NO EVALUADO",
            2,
            false,
            false
          )
        );
        this.selectedRows.forEach((element) =>
          this.savePostulante(
            element,
            "INDUCCION",
            "NO EVALUADO",
            3,
            false,
            false
          )
        );
        this.selectedRows.forEach((element) =>
          this.savePostulante(
            element,
            "CONTRATO",
            "NO CONTRATADO",
            4,
            false,
            false
          )
        );
        this.selectedRows.forEach((element) =>
          this.activarCondicionRequerimiento(element)
        );
      }
    },
    Ayuda() {
      console.log("Click en el primero");
    },
    reiniciarListadoPostulantes() {
      if (this.cuallistar == "NORMAL") {
        console.log("Vuelve a listar postulantes normal");
        this.ListarPostulantes2();
      } else {
        console.log("Vuelve a listar postulantes vecinos");
        this.ListarPostulantesVecinos2();
      }
      this.ListarPostulantesElegidos();
    },
    savePostulante(p_id, p_etapa, p_estado, p_orden, p_condicion, p_actual) {
      console.log("Entra a save postulante");
      let me = this;
      let today = new Date().toISOString().substr(0, 10);
      let dateayuda = new Date();
      // add a day
      dateayuda.setDate(dateayuda.getDate() + 1);
      let tomorrow = dateayuda.toISOString().substr(0, 10);
      console.log(
        "Fecha hoy" + today.toString() + " Mañana:" + tomorrow.toString()
      );
      axios
        .post("api/Postulaciones/Crear", {
          idrequerimiento: Number(me.requerimientoid),
          idindividuo: Number(p_id),
          etapa: p_etapa,
          estado: p_estado,
          orden: Number(p_orden),
          observaciones: "",
          condicion: p_condicion,
          actual: p_actual,
        })
        .then((response) => {
          console.log(
            "Se guardo la postulacion de " +
              id +
              "con el codigo" +
              response.data.toString()
          );
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    eliminarPostulacion(item) {
      console.log("Entra a eliminar postulacion");
      let me = this;
      axios
        .delete(
          "api/Postulaciones/EliminarbyPersonaRequerimiento/" +
            item.idindividuo +
            "/" +
            item.idrequerimiento,
          {}
        )
        .then((response) => {
          console.log("Postulacion eliminada");
          me.editItem();
          me.desactivarCondicionRequerimiento(item.idindividuo);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    actualizarPostulacionByPostualacion(item,etapa) {
      console.log("Ingresa a actualizar postulaciones");
      let me = this;
      let siguiente = Number(item.orden) + 1;
      if (Number(item.orden) < 4) {
        //Si es APTO se pone condicion,actual al siguiente y activamos condicion requerimiento
        if (item.estado == "APTO") {
          me.actualizarPostulacionByReqIndOrd(
            item.idrequerimiento,
            item.idindividuo,
            item.orden,
            item.estado,
            item.observaciones,
            true,
            false
          );
          if (Number(item.orden) < 3) {
            me.actualizarPostulacionByReqIndOrd(
              item.idrequerimiento,
              item.idindividuo,
              siguiente,
              "NO EVALUADO",
              "",
              true,
              true
            );
          } else {
            me.actualizarPostulacionByReqIndOrd(
              item.idrequerimiento,
              item.idindividuo,
              siguiente,
              "NO CONTRATADO",
              "",
              true,
              true
            );
          }
          me.activarCondicionRequerimiento(item.idindividuo);
        }
        //Si es no APTO se queda con el actual, los demas se vuelven no actuales
        if (item.estado == "NO APTO") {
          me.actualizarPostulacionByReqIndOrd(
            item.idrequerimiento,
            item.idindividuo,
            item.orden,
            item.estado,
            item.observaciones,
            true,
            true
          );
          //Actualizamos para que de ahi para adelante los demas se ponen en no actual
          me.actualizarPostulacionActualByReqIndRan(
            item.idrequerimiento,
            item.idindividuo,
            siguiente,
            3,
            false
          );
          /*
          //Actualizar para que de ahi adelante se pongan en NO APTO
            me.actualizarPostulacionEstadoByReqIndRan(
              item.idrequerimiento,
              item.idindividuo,
              siguiente,
              3,
              "NO APTO"
            );*/
          //Desactivamos la condicion de requerimiento
          me.desactivarCondicionRequerimiento(item.idindividuo);
        }
        //Se queda en actual y condicion
        if (item.estado == "NO EVALUADO") {
          me.actualizarPostulacionByReqIndOrd(
            item.idrequerimiento,
            item.idindividuo,
            item.orden,
            item.estado,
            item.observaciones,
            true,
            true
          );
        }
      } else {
        console.log("Postulacion etapa Contrato");
        me.individuoid = item.idindividuo;
        if (item.estado == "CONTRATADO") {
          me.actualizarPostulacionByReqIndOrd(
            item.idrequerimiento,
            item.idindividuo,
            item.orden,
            item.estado,
            item.observaciones,
            true,
            true
          );
          //Se hace el contrato
          me.desactivarCondicionRequerimiento(item.idindividuo);
          me.actualizarPostulacionContratadoByReqIndRan(
            item.idrequerimiento,
            item.idindividuo,
            1,
            4,
            true
          );
          me.guardarEmpleadoFinal(item);
        }
        if (item.estado == "NO CONTRATADO") {
          me.actualizarPostulacionByReqIndOrd(
            item.idrequerimiento,
            item.idindividuo,
            item.orden,
            item.estado,
            item.observaciones,
            true,
            true
          );
          //Se desactiva la condicio de rquerimiento
          me.desactivarCondicionRequerimiento(item.idindividuo);
        }
      }
    },
    listaretapa(etapa){
      let me=this;
      console.log("Entra a listar etapas");
      if(etapa==1){
        console.log("Entra a listar etapa 1");
        me.listarPostulantesEtapa1();}
      if(etapa==2){
      console.log("Entra a listar etapa 2");
        me.listarPostulantesEtapa2();}
      if(etapa==3){
      console.log("Entra a listar etapa 3");
        me.listarPostulantesEtapa3();}
      if(etapa==4){
      console.log("Entra a listar etapa 4");
        me.listarPostulantesEtapa4();}
    },
    //Actualizar postulacion asociado a la etapa (en base a requerimiento, individuo y orden) y actualizar estado, observaciones, condicion y actual
    actualizarPostulacionByReqIndOrd(
      p_idrequerimiento,
      p_idindividuo,
      p_orden,
      p_estado,
      p_observaciones,
      p_condicion,
      p_actual
    ) {
      console.log("Entra a actualizar etapa orden: " + p_orden);
      let me = this;
      axios
        .put("api/Postulaciones/ActualizarEtapa2", {
          idrequerimiento: Number(p_idrequerimiento),
          idindividuo: Number(p_idindividuo),
          orden: Number(p_orden),
          estado: p_estado,
          observaciones: p_observaciones,
          condicion: p_condicion,
          actual: p_actual,
        })
        .then((response) => {
          console.log("Actualizo estado");
          me.error = "Registro exitoso";
          me.color = "#2A3B4D";
          me.icon = "mdi-thumb-up";
          me.snackbar = true;
          me.listaretapa(p_orden);
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;
        });
    },
    //Actualizar postulacion asociado a la etapa (en base a requerimiento, individuo y rango) y actualizar actual
    actualizarPostulacionActualByReqIndRan(
      p_idrequerimiento,
      p_idindividuo,
      p_rangoinicio,
      p_rangofin,
      p_actual
    ) {
      console.log("Entra a actualizar actual por ReqIndRan: ");
      let me = this;
      axios
        .put("api/Postulaciones/ActualizarEtapaActual", {
          idrequerimiento: Number(p_idrequerimiento),
          idindividuo: Number(p_idindividuo),
          rangoinicio: Number(p_rangoinicio),
          rangofin: Number(p_rangofin),
          actual: p_actual,
        })
        .then((response) => {
          console.log("Actualizo actual estado");
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Actualizar postulacion asociado a la etapa (en base a requerimiento, individuo y rango) y actualizar etapa
    actualizarPostulacionEstadoByReqIndRan(
      p_idrequerimiento,
      p_idindividuo,
      p_rangoinicio,
      p_rangofin,
      p_estado
    ) {
      console.log("Entra a actualizar estado por ReqIndRan: ");
      let me = this;
      axios
        .put("api/Postulaciones/ActualizarEtapaEstado", {
          idrequerimiento: Number(p_idrequerimiento),
          idindividuo: Number(p_idindividuo),
          rangoinicio: Number(p_rangoinicio),
          rangofin: Number(p_rangofin),
          estado: p_estado,
        })
        .then((response) => {
          console.log("Actualizo estado por rango");
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Actualizar postulacion activar contratado
    actualizarPostulacionContratadoByReqIndRan(
      p_idrequerimiento,
      p_idindividuo,
      p_rangoinicio,
      p_rangofin,
      p_contratado
    ) {
      console.log("Entra a actualizar estado por ReqIndRan: ");
      let me = this;
      axios
        .put("api/Postulaciones/ActualizarEtapaContratado", {
          idrequerimiento: Number(p_idrequerimiento),
          idindividuo: Number(p_idindividuo),
          rangoinicio: Number(p_rangoinicio),
          rangofin: Number(p_rangofin),
          contratado: p_contratado,
        })
        .then((response) => {
          console.log("Actualizo contratado por rango");
          me.listarPostulantesEtapa4();
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    ListarPostulantesElegidos() {
      let me = this;
      me.postulanteselegidos = [];
      axios
        .get("api/Postulaciones/ListarByRequerimiento/" + me.requerimientoid)
        .then(function (response) {
          console.log("Listar postulantes por requerimiento");
          me.postulanteselegidos = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    //============== Reportes administracion
    ListarPostulantesAdministracion1() {
      let me = this;
      me.postulantesadministracion1 = [];
      axios
        .post("api/Postulaciones/ListarEstatusPostulaciones", {})
        .then(function (response) {
          console.log("Listar postulantes admin 1");
          me.postulantesadministracion1 = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarPostulantesAdministracion2() {
      let me = this;
      me.postulantesadministracion2 = [];
      axios
        .post("api/Postulaciones/ListarEstatusPostulaciones2", {})
        .then(function (response) {
          console.log("Listar postulantes admin 2");
          me.postulantesadministracion2 = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    //====================Etapa 1
    listarPostulantesEtapa1() {
      let me = this;
      me.postulantesetapa1 = [];
      axios
        .get(
          "api/Postulaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            1
        )
        .then(function (response) {
          console.log("Listar postulantes por requerimiento y etapa");
          me.postulantesetapa1 = response.data;
          //me.ListarProgramacionEtapa1();
          me.listarinfoEtapa1(me.postulantesetapa1);
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacionEtapa1() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            1
        )
        .then(function (response) {
          me.postulantesetapa1fechainicio = response.data.fecha_inicio;
          me.postulantesetapa1fechafin = response.data.fecha_fin;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarinfoEtapa1(data) {
      console.log("Entra a info Etapa 1");
      let me = this;
      let aptos = 0;
      let noaptos = 0;
      let noevaluados = 0;

      for (var i = 0; i < data.length; i++) {
        if (data[i].estado == "APTO") aptos++;
        else if (data[i].estado == "NO APTO") noaptos++;
        else noevaluados++;
      }
      me.postulantesetapa1aptos = aptos;
      me.postulantesetapa1noaptos = noaptos;
      me.postulantesetapa1noevaluados = noevaluados;
      console.log("Aptos" + aptos);
    },
    //====================Etapa 2
    listarPostulantesEtapa2() {
      let me = this;
      me.e6 = 2;
      me.postulantesetapa2 = [];
      axios
        .get(
          "api/Postulaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            2
        )
        .then(function (response) {
          console.log("Listar postulantes por requerimiento y etapa");
          me.postulantesetapa2 = response.data;
          //me.ListarProgramacionEtapa2();
          me.listarinfoEtapa2(me.postulantesetapa2);
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacionEtapa2() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            2
        )
        .then(function (response) {
          me.postulantesetapa2fechainicio = response.data.fecha_inicio;
          me.postulantesetapa2fechafin = response.data.fecha_fin;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarinfoEtapa2(data) {
      let me = this;
      let aptos = 0;
      let noaptos = 0;
      let noevaluados = 0;

      for (var i = 0; i < data.length; i++) {
        if (data[i].estado == "APTO") aptos++;
        else if (data[i].estado == "NO APTO") noaptos++;
        else noevaluados++;
      }
      me.postulantesetapa2aptos = aptos;
      me.postulantesetapa2noaptos = noaptos;
      me.postulantesetapa2noevaluados = noevaluados;
    },
    //====================Etapa 3
    listarPostulantesEtapa3() {
      let me = this;
      me.e6 = 3;
      me.postulantesetapa3 = [];
      axios
        .get(
          "api/Postulaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            3
        )
        .then(function (response) {
          console.log("Listar postulantes por requerimiento y etapa");
          me.postulantesetapa3 = response.data;
          //me.ListarProgramacionEtapa3();
          me.listarinfoEtapa3(me.postulantesetapa3);
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacionEtapa3() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            3
        )
        .then(function (response) {
          me.postulantesetapa3fechainicio = response.data.fecha_inicio;
          me.postulantesetapa3fechafin = response.data.fecha_fin;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarinfoEtapa3(data) {
      let me = this;
      let aptos = 0;
      let noaptos = 0;
      let noevaluados = 0;

      for (var i = 0; i < data.length; i++) {
        if (data[i].estado == "APTO") aptos++;
        else if (data[i].estado == "NO APTO") noaptos++;
        else noevaluados++;
      }
      me.postulantesetapa3aptos = aptos;
      me.postulantesetapa3noaptos = noaptos;
      me.postulantesetapa3noevaluados = noevaluados;
    },
    //====================Etapa 4
    listarPostulantesEtapa4() {
      let me = this;
      me.e6 = 4;
      me.postulantesetapa4 = [];
      axios
        .get(
          "api/Postulaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            4
        )
        .then(function (response) {
          console.log("Listar postulantes por requerimiento y etapa");
          me.postulantesetapa4 = response.data;
          //me.ListarProgramacionEtapa4();
          me.listarinfoEtapa4(me.postulantesetapa4);
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacionEtapa4() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            4
        )
        .then(function (response) {
          me.postulantesetapa4fechainicio = response.data.fecha_inicio;
          me.postulantesetapa4fechafin = response.data.fecha_fin;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    listarinfoEtapa4(data) {
      let me = this;
      let contratados = 0;

      for (var i = 0; i < data.length; i++) {
        if (data[i].estado == "CONTRATADO") contratados++;
      }
      me.postulantesetapa4contratados = contratados;
    },
    editItemReporte() {
      this.ListarPostulantesResumen1();
      this.ListarPostulantesResumen2();
      this.ListarPostulantesResumen3();
    },
    ListarPostulantesResumen1() {
      let me = this;
      me.postulantesresumenadministracion1 = [];
      axios
        .post("api/Postulaciones/ListarEstatusResumen1/" + me.requerimientoid)
        .then(function (response) {
          console.log("Listar postulantes resumen por requerimiento");
          me.postulantesresumenadministracion1 = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarPostulantesResumen2() {
      let me = this;
      me.postulantesresumenadministracion2 = [];
      axios
        .post("api/Postulaciones/ListarEstatusResumen2/" + me.requerimientoid)
        .then(function (response) {
          console.log("Listar postulantes resumen por requerimiento");
          me.postulantesresumenadministracion2 = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarPostulantesResumen3() {
      let me = this;
      me.postulantesresumenadministracion3 = [];
      axios
        .post("api/Postulaciones/ListarEstatusResumen3/" + me.requerimientoid)
        .then(function (response) {
          console.log(
            "Listar postulantes resumen por requerimiento contratados"
          );
          me.postulantesresumenadministracion3 = response.data;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    cerrarRequerimiento() {
      let me = this;
      console.log("Entra para verificar si cierra el requerimiento");
      axios
        .put(
          "/api/Requerimientos/CerrarRequerimiento/" + me.requerimientoid,
          {}
        )
        .then(function (response) {
          console.log("Entro a Cerrar requerimiento");
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //==================== Programaciones
    ListarProgramaciones() {
      let me = this;
      me.ListarProgramacion1();
      me.ListarProgramacion2();
      me.ListarProgramacion3();
      me.ListarProgramacion4();
    },
    LimpiarProgramacion() {
      let me = this;
      me.etapa1fecha_inicio = "";
      me.etapa1fecha_fin = "";
      me.etapa1duracion = "";
      me.etapa2fecha_inicio = "";
      me.etapa2fecha_fin = "";
      me.etapa2duracion = "";
      me.etapa3fecha_inicio = "";
      me.etapa3fecha_fin = "";
      me.etapa3duracion = "";
      me.etapa4fecha_inicio = "";
      me.etapa4fecha_fin = "";
      me.etapa4duracion = "";
    },
    ListarProgramacion1() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            1
        )
        .then(function (response) {
          me.etapa1fecha_inicio = response.data.fecha_inicio;
          me.etapa1fecha_fin = response.data.fecha_fin;
          me.etapa1duracion = response.data.dias;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacion2() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            2
        )
        .then(function (response) {
          me.etapa2fecha_inicio = response.data.fecha_inicio;
          me.etapa2fecha_fin = response.data.fecha_fin;
          me.etapa2duracion = response.data.dias;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacion3() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            3
        )
        .then(function (response) {
          me.etapa3fecha_inicio = response.data.fecha_inicio;
          me.etapa3fecha_fin = response.data.fecha_fin;
          me.etapa3duracion = response.data.dias;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    ListarProgramacion4() {
      let me = this;
      axios
        .get(
          "api/Programaciones/ListarByRequerimientoEtapa/" +
            me.requerimientoid +
            "/" +
            4
        )
        .then(function (response) {
          me.etapa4fecha_inicio = response.data.fecha_inicio;
          me.etapa4fecha_fin = response.data.fecha_fin;
          me.etapa4duracion = response.data.dias;
          me.verificarFechaFinal();
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    validarRegistro(p1_fechainicio, p1_fechafin) {
      let me = this;
      console.log("Entra a validar registro");
      let respuesta = true;
      if (p1_fechainicio == "" || p1_fechafin == "") {
        console.log("Ingresa a error de validacion");
        respuesta = false;
      }
      console.log("respuesta: " + respuesta);
      return respuesta;
    },
    saveProgramacion() {
      let me = this;
      me.actualizarProgramacion(
        me.requerimientoid,
        1,
        me.etapa1fecha_inicio,
        me.etapa1fecha_fin,
        me.etapa1duracion
      );
      me.actualizarProgramacion(
        me.requerimientoid,
        2,
        me.etapa2fecha_inicio,
        me.etapa2fecha_fin,
        me.etapa2duracion
      );
      me.actualizarProgramacion(
        me.requerimientoid,
        3,
        me.etapa3fecha_inicio,
        me.etapa3fecha_fin,
        me.etapa3duracion
      );
      me.actualizarProgramacion(
        me.requerimientoid,
        4,
        me.etapa4fecha_inicio,
        me.etapa4fecha_fin,
        me.etapa4duracion
      );
    },
    actualizarProgramacion(
      p_idreque,
      p_orden,
      p_fechainicio,
      p_fechafin,
      p_dias
    ) {
      let me = this;
      console.log("Entra a actualizacion programacion");
      if (me.validarRegistro(p_fechainicio, p_fechafin) == true) {
        let me = this;
        axios
          .put("/api/Programaciones/ActualizarEtapa", {
            idrequerimiento: Number(p_idreque),
            orden: Number(p_orden),
            fecha_inicio: p_fechainicio,
            fecha_fin: p_fechafin,
            dias: Number(p_dias),
          })
          .then(function (response) {
            console.log("Actualizo programacion: " + p_orden);
            if (p_orden == 4) {
              me.color = "#2A3B4D";
              me.icon = "mdi-thumb-up";
              me.error = "Registro exitoso";
              me.snackbar = true;
            }
          })
          .catch(function (error) {
            console.log(error.response);
            if (p_orden == 4) {
              if (error.response.status == 400) {
                me.error = error.response.data.toString();
              }
              me.color = "#E53935";
              me.icon = "mdi-alert";
              me.snackbar = true;
            }
          });
      }
    },
    //========================== Contratos
    guardarEmpleadoFinal(item) {
      let me = this;
      console.log("Entra a guardar empleado final");
      axios
        .post("/api/Empleados/Crear", {
          dni: item.dni,
          nombres: item.nombres.toUpperCase(),
          apellidos: item.apellidos.toUpperCase(),
          fecha_nacimiento: item.fecha_nacimiento,
          sexo: item.sexo,
          telefono: item.telefono,
          email: item.email,
          estado_civil: item.estado_civil,
          usuario: "",
          contraseña: "",
          idarea: me.areaid,
          condicion: true,
          rol: "NINGUNO",
          tipo: "EMPLEO",
        })
        .then(function (response) {
          me.empleadoid = Number(response.data);
          console.log("Save empleado: " + me.empleadoid.toString());
          me.guardarContrato();
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    guardarContrato() {
      let me = this;
      axios
        .post("/api/Contratos/Crear", {
          fecha_inicio: me.requerimientofecha_inicio,
          fecha_fin: me.requerimientofecha_fin,
          idempleado: me.empleadoid,
          condicion: true,
          idrequerimiento: me.requerimientoid,
          idarea: me.areaid,
          puesto: me.requerimientoperfil.toUpperCase(),
        })
        .then(function (response) {
          me.contratoid = Number(response.data);
          console.log("Save contrato: " + me.contratoid.toString());
          //me.actualizarEmpleadoExperiencia(me.empleadoid);
          me.cerrarRequerimiento();
          me.guardarExperienciaFinal(me.individuoid);
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },
    guardarExperienciaFinal(p_idindividuo) {
      let me = this;
      axios
        .post("/api/Experiencias/Crear", {
          empresa: me.requerimientoempresa.toUpperCase(),
          puesto: me.requerimientoperfil.toUpperCase(),
          fechainicio: me.requerimientofecha_inicio,
          fechafin: me.requerimientofecha_fin,
          actual: true,
          bateas: true,
          idindividuo: Number(p_idindividuo),
          idcontrato: Number(me.contratoid),
        })
        .then(function (response) {
          console.log("Experiencia Creada");
          me.experienciaid = Number(response.data);
          console.log(
            "ID experiencia: " +
              me.experienciaid +
              ", Id empleado: " +
              me.empleadoid +
              " y Id individuo: " +
              me.individuoid
          );
          me.actualizarEmpleadoExperiencia(
            me.experienciaid,
            me.empleadoid,
            me.individuoid
          );
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    actualizarEmpleadoExperiencia(
      p_experienciaid,
      p_empleadoid,
      p_individuoid
    ) {
      let me = this;
      console.log("Entra para actualizar id empleado en experiencia");
      axios
        .put("/api/Experiencias/ActualizarEmpleado", {
          idexperiencia: Number(p_experienciaid),
          idempleado: Number(p_empleadoid),
        })
        .then(function (response) {
          console.log("Actualiza ID empleado en experiencia");
          me.activardesactivarCondicionEmpleo(p_individuoid);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    activardesactivarCondicionEmpleo(p_idindividuo) {
      console.log("Entra para activar y desactivar");
      let me = this;
      axios
        .put("/api/Individuos/ActivarEmpleo/" + p_idindividuo, {})
        .then(function (response) {
          console.log("Activar condicion empleo");
          //me.listarExperiencia();
          /*me.color = "#2A3B4D";
          me.icon = "mdi-thumb-up";
          me.error = "Registro de contrato exitoso";
          me.snackbar = true;*/
        })
        .catch(function (error) {
          console.log(error.response);
          /* if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;*/
        });
    },
    fetchData() {
      let me = this;
      this.listLoading = true
      axios
        .post("api/FiltrosContratos/ListarContratosExport", {
          tipo_empresa: me.tipos_empresa.join(","),
          sector: me.rubro_empresa.join(","),
          tipo_locacion: me.requerimiento_tipolocacion.join(","),
          clasificacion: me.clasificacion_locacion.join(","),
          fecha_inicio: me.fecha_inicio,
          fecha_fin: me.fecha_fin,
          monto_contrato_i: Number(me.montoslider[0]),
          monto_contrato_f: Number(me.montoslider[1]),
          f_tipo_empresa: me.chktipoempresa,
          f_tipo_locacion: me.chktipolocacion,
          f_clasificacion: me.chkclocacion,
          f_fechas: me.chkfechas,
          f_monto_contrato: me.chkmonto,
          f_sector: me.chkrubroempresa,
        })
      .then(response => {
        var obj = response.data;
          for (var i in obj) {
            this.listaContratosExportar.push(obj[i]);
          }
        this.listLoading = false
      })
    },
    handleDownload() {
      this.downloadLoading = true
      this.fetchData()
      import('../vendor/Export2Excel').then(excel => {
        const tHeader = ['RUC', 'Razon Social', 'Abreviatura', 'Giro Comercial', 'Sector','Descripción', 'Tipo Empresa', 'Tipo Locación',
        'Representante','DNI de Representante','Celular de Representante', 'Primer Contacto','Segundo Contacto','Producto/Servicio Principal',
        'Producto/Servicio Secundario','Tiene Licencia','Numero de licencia','Tiene Boleta','Tiene Factura','Locación','Contrato o Servicio',
        'Abreviatura Contrato','Descripción de contrato', 'Es Conflictivo','Observaciones','Monto de contrato','Calidad de Servicio',
        'Observaciones del Servicio', 'Fecha Inicio','Fecha Fin']
        const filterVal = ['ruc', 'razonsocial', 'abreviatura', 'giro_comercial', 'sector','descripcion','tipo_empresa','tipo_locacion','representante',
        'representante_dni','representante_cel','primer_contacto','segundo_contacto','pro_ser_principal','pro_ser_secundario','licencia','numero_licencia',
        'boleta','factura','locacion','contratosempresas','abreviaturacontratosempresas','descripcioncontratosempresas','conflictivo','observaciones',
        'monto_contrato','servicio_calidad','servicio_observaciones','fecha_inicio','fecha_fin']
        //const list = this.listaContratosExportar
        const list = JSON.parse(JSON.stringify(this.listaContratosExportar))
        const list2 = [{'id':'1', 'title':'titulo', 'author':'autor', 'pageviews':2, 'display_time':'2'},{'id':'1', 'title':'titulo', 'author':'autor', 'pageviews':2, 'display_time':'2'}]
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
.v-data-table {
  max-width: 100%;
}
.select-width {
  width: 100px;
}
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
v-text-field[type="date"]::-webkit-inner-spin-button,
v-text-field[type="date"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.v-text-field__slot {
  width: 120px;
}
</style>